import { QuestionOutlineIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Heading,
  HStack,
  Image,
  Input,
  Radio,
  RadioGroup,
  Select,
  Stack,
  StackDivider,
  Text,
  Textarea,
  Tooltip,
  useDisclosure,
  useToast,
  VStack
} from '@chakra-ui/react';
import { AxiosError } from 'axios';
import {
  MutableRefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { PlusIcon } from '../../../../assets/icons/PlusIcon';
import { TrashIcon } from '../../../../assets/icons/TrashIcon';
import { UploadIcon } from '../../../../assets/icons/UploadIcon';
import { ColorPalette } from '../../../../components/data/utils/ColorPalette';
import { WhiteLabelWrapper } from '../../../../components/layouts/WhiteLabelWrapper';
import { WhiteLabelNavigator } from '../../../../components/navigation/WhiteLabelNavigator';
import { BoxCritical } from '../../../../components/white-label/BoxCritical';
import {
  ModalImages,
  ModalSelectImage as ModalSelectBannerImage
} from '../../../../components/white-label/modals/ModalSelectImage';
import { WhiteLabelSteps } from '../../../../components/white-label/WhiteLabelSteps';
import { ModalCropImage as ModalCropImageLogo } from '../../../../components/widgets/ModalCropImage';
import { StepsFormActions } from '../../../../contexts/StepsContext';
import { useStepsForm } from '../../../../hooks/useStepsForm';
import { apiSensedia } from '../../../../services/api-sensedia';
import { getDominio } from '../../../../services/white-label/dominio.service';
import {
  listAllImages,
  sendImageToBucket
} from '../../../../services/white-label/storage.service';

let apiWl = apiSensedia;

if (process.env.NODE_ENV != 'development') {
  apiWl = apiSensedia;
}

export const StepOne = (): JSX.Element => {
  const { state: routerState } = useLocation() as any;
  const { idWebsite } = useParams();

  const fieldsInputRefWebsiteName =
    useRef() as MutableRefObject<HTMLInputElement>;
  const fieldsInputRefLogoName = useRef() as MutableRefObject<HTMLInputElement>;
  const fieldsInputRefWhatsappNumber = useRef() as MutableRefObject<any>;
  const fieldsInputRefBanner = useRef() as MutableRefObject<HTMLDivElement>;
  const fieldsInputRefTitle = useRef() as MutableRefObject<HTMLTextAreaElement>;
  const fieldsInputRefSubtitle =
    useRef() as MutableRefObject<HTMLTextAreaElement>;

  const {
    isOpen: isOpenModalCropLogo,
    onOpen: onOpenModalCropLogo,
    onClose: onCloseModalCropLogo
  } = useDisclosure();

  const { state, setState } = useStepsForm();

  const [criticalGecad, setCriticalGecad] = useState({
    COR_SITE: '',
    COR_BOTOES: '',
    NOME_SITE: '',
    LOGO: '',
    LOGO_PALAVRA: '',
    NUMERO_WHATSAPP: '',
    IMAGEM_SECAO_1: '',
    TITULO_SECAO_1: '',
    SUBTITULO_SECAO_1: ''
  });

  // const [exibirCriticaCorSite, setExibirCriticaCorSite] = useState(false);

  const [, setNameImgBanner] = useState<FileList | null | string>();
  const [, setNameImgLogo] = useState<FileList | null | string>();
  const [corretorImages, setCorretorImages] = useState<ModalImages[]>([]);
  const [dataListPartner, setDataListPartner] = useState<any[]>();

  const hasLogo = state.selectedFileLogo || state.selectedFileLogoName;
  const hasBanner = state.selectedFileBanner || state.selectedFileBannerName;

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [selectedNameLogoLength, setSelectedNameLogoLength] = useState(0);
  const [descriptionCompanyTitleLength, setDescriptionCompanyTitleLength] =
    useState(0);
  const [
    descriptionCompanySubtitleLength,
    setDescriptionCompanySubtitleLength
  ] = useState(0);

  const [isInvalidSubdomain, setInvalidSubdomain] = useState(false);

  const [previewImage, setPreviewImage] = useState('url(undefined)');

  const toast = useToast();

  const navigate = useNavigate();

  const codigoCorretor = useMemo(() => {
    return state.corretorId;
  }, [state.corretorId]);

  const handleModalSelectImage = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleChangeLogo = (e: any) => {
    if (e.target.files) {
      console.log('', e.target.files[0].size);
      if (
        (e.target.files[0].type !== 'image/png' &&
          e.target.files[0].type !== 'image/jpeg') ||
        e.target.files[0].size / 1024 ** 2 >= 1
      ) {
        e.target.value = '';

        toast({
          position: 'top',
          description:
            'Tamanho superior a 1mb. Ou formato diferente de png/jpeg.',
          status: 'error',
          duration: 4000,
          isClosable: true
        });

        return;
      }

      onOpenModalCropLogo();

      const file = e.target.files[0];
      const url = URL.createObjectURL(file);

      setNameImgLogo(file.name);
      setState({
        type: StepsFormActions.setSelectedFileLogo,
        payload: url
      });
    }
  };

  const handleUploadClick = () => {
    const imgUpload = document.getElementById('imgUploadLogo');

    if (imgUpload) {
      imgUpload.click();
    }
  };

  const handleUploadLogo = () => {
    handleUploadClick();
  };

  const handleImageSelectedGalleryBanner = (
    currentSelectedImage: any,
    fileNameForUrl: any
  ) => {
    const file = fileNameForUrl;

    setNameImgBanner(currentSelectedImage);
    setState({
      type: StepsFormActions.setSelectedFileBanner,
      payload: file
    });

    setState({
      type: StepsFormActions.setSelectedFileBannerName,
      payload: currentSelectedImage
    });
  };

  const getPartner = async () => {
    // setState({
    //   type: StepsFormActions.setPartner,
    //   payload: partner
    // });
    try {
      const res2 = await apiWl.get(`/parceiros`);
      console.log('dados evs', res2.data);
      setDataListPartner(res2.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetWebsite = async () => {
    try {
      const res = await apiWl.get(`/websites/${idWebsite}`);
      const resForLogo = res.data.website_subdomain
        ? res.data.contains_sulamerica_logo
        : true;
      const resForColor = res.data.website_subdomain
        ? res.data.website_color
        : '#FF5000';

      const previewImageSave = `url(${res.data.website_logo_url})`;

      setPreviewImage(previewImageSave);

      setState({
        type: StepsFormActions.setCorretorId,
        payload: res.data.codigo_corretor
      });
      setState({
        type: StepsFormActions.setCurrentWebsiteColor,
        payload: resForColor
      });
      setState({
        type: StepsFormActions.setCurrentButtonsColor,
        payload: res.data.buttons_color
      });
      setState({
        type: StepsFormActions.setWebsiteAddress,
        payload: res.data.website_subdomain
      });
      setState({
        type: StepsFormActions.setWebSiteTitle,
        payload: res.data.website_title
      });
      setState({
        type: StepsFormActions.setSelectedNameLogo,
        payload: res.data.name_logo
      });
      setState({
        type: StepsFormActions.setLogoSulamerica,
        payload: resForLogo
      });
      setState({
        type: StepsFormActions.setWhatsappNumber,
        payload: res.data.whatsapp
      });
      setState({
        type: StepsFormActions.setCompanyTitle,
        payload: res.data.description_first_sec_title
      });
      setState({
        type: StepsFormActions.setCompanySubtitle,
        payload: res.data.description_first_sec_subtitle
      });
      setState({
        type: StepsFormActions.setSelectedFileBanner,
        payload: res.data.banner_first_sec_url
      });
      setState({
        type: StepsFormActions.setSelectedFileLogo,
        payload: res.data.website_logo_url
      });
      setState({
        type: StepsFormActions.setSelectedFileBannerName,
        payload: res.data.banner_first_sec
      });
      setState({
        type: StepsFormActions.setSelectedFileLogoName,
        payload: res.data.website_logo
      });
      setState({
        type: StepsFormActions.setEv,
        payload: res.data.ev
      });

      if (res.data.ultimaCritica) {
        const objetoCritica = {
          COR_SITE:
            res.data.ultimaCritica.parametros_website.param_cor_site || '',
          COR_BOTOES:
            res.data.ultimaCritica.parametros_website.param_cor_botoes || '',
          NOME_SITE:
            res.data.ultimaCritica.parametros_website.param_nome_site || '',
          LOGO: res.data.ultimaCritica.parametros_website.param_logo || '',
          LOGO_PALAVRA:
            res.data.ultimaCritica.parametros_website.param_logo_palavra || '',
          NUMERO_WHATSAPP:
            res.data.ultimaCritica.parametros_website.param_numero_whatsapp ||
            '',
          IMAGEM_SECAO_1:
            res.data.ultimaCritica.parametros_website.param_imagem_secao_1 ||
            '',
          TITULO_SECAO_1:
            res.data.ultimaCritica.parametros_website.param_titulo_secao_1 ||
            '',
          SUBTITULO_SECAO_1:
            res.data.ultimaCritica.parametros_website.param_subtitulo_secao_1 ||
            ''
        };

        setCriticalGecad({ ...objetoCritica });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePutWebsite = async () => {
    const body = {
      codigo: idWebsite,
      website_color: state.currentWebsiteColor,
      buttons_color: state.currentButtonsColor,
      website_subdomain: state.websiteAddress,
      website_title: state.websiteTitle,
      contains_sulamerica_logo: state.logoSulamerica,
      name_logo: state.selectedNameLogo,
      whatsapp: state.whatsappNumber,
      description_first_sec_title: state.companyTitle,
      description_first_sec_subtitle: state.companySubtitle,
      banner_first_sec: state.selectedFileBannerName,
      website_logo: state.selectedFileLogoName,
      ev: state.ev
    };
    return await apiWl.put(`/websites/${idWebsite}`, body);
  };

  const checkNameAvailabilityNoMessage = async (
    websiteId: string,
    name: string
  ) => {
    const body = {
      codigo_website: websiteId,
      website_name: name
    };

    try {
      const response = await apiWl.post(`/subdominios`, body);

      if (response.data.subdominio) {
        setState({
          type: StepsFormActions.setWebsiteAddress,
          payload: response.data.subdominio
        });
        setInvalidSubdomain(false);
      }
    } catch (error: any) {
      console.log('erro aqui', error?.response?.data.message);

      setInvalidSubdomain(true);
    }
  };

  const checkNameAvailability = async (websiteId: string, name: string) => {
    const body = {
      codigo_website: websiteId,
      website_name: name
    };

    try {
      const response = await apiWl.post(`/subdominios`, body);

      if (response.data.subdominio) {
        setState({
          type: StepsFormActions.setWebsiteAddress,
          payload: response.data.subdominio
        });
        setInvalidSubdomain(false);
      }
    } catch (error: any) {
      console.log('erro aqui', error?.response?.data.message);

      toast({
        position: 'top',
        description: error?.response?.data.message,
        status: 'error',
        duration: 6000,
        isClosable: true
      });

      setInvalidSubdomain(true);
    }
  };

  const handleSubmit = async (e: any) => {
    const bannerDivElement = fieldsInputRefBanner.current;
    const bannerBackgroundImage =
      window.getComputedStyle(bannerDivElement).backgroundImage;

    e.preventDefault();
    e.stopPropagation();

    if (isInvalidSubdomain) {
      toast({
        position: 'top',
        description: `Favor verifique os erros nos campos: ${
          isInvalidSubdomain
            ? 'Nome website: Nome do site já está em uso\n'
            : ''
        }`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefWebsiteName.current.value === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefWebsiteName.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (
      (fieldsInputRefLogoName.current.value === '' &&
        state.selectedFileLogo === undefined) ||
      (fieldsInputRefLogoName.current.value === '' &&
        state.selectedFileLogo === '')
    ) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefLogoName.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefWhatsappNumber.current.value === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefWhatsappNumber.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefWhatsappNumber.current.value.length < 10) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefWhatsappNumber.current.id} está incorreto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefWhatsappNumber.current.value.length > 11) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefWhatsappNumber.current.id} está incorreto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (bannerBackgroundImage === 'none') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefBanner.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefTitle.current.defaultValue === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefTitle.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefSubtitle.current.defaultValue === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefSubtitle.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (!state.ev) {
      toast({
        position: 'top',
        description: `É obrigatório selecionar uma EV para prosseguir`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else {
      try {
        await handlePutWebsite();
        navigate(`/corretor/white-label/step-two/${idWebsite}/`);
      } catch (e: any) {
        const error = e as AxiosError;
        console.log('resposta put ', {
          status: error.response.status,
          data: error.response.data
        });
      }
    }
  };

  const handlePrevImage = (data: string) => {
    setPreviewImage(`url(${data})`);
    setState({
      type: StepsFormActions.setSelectedNameLogo,
      payload: ''
    });
  };

  const handleLogoImageAfterCropped = useCallback(
    async (imageBase64: string) => {
      try {
        setState({
          type: StepsFormActions.setSelectedFileLogo,
          payload: imageBase64
        });

        const pathName = `${codigoCorretor}/img-logo-${Date.now()}.jpg`;

        const data = imageBase64;

        await sendImageToBucket({ data, pathName });
        setState({
          type: StepsFormActions.setSelectedFileLogoName,
          payload: pathName
        });

        handlePrevImage(data);
      } catch (error) {
        toast({
          title: 'Não foi possível enviar sua imagem',
          description: 'Tente novamente mais tarde',
          status: 'error'
        });
      }
    },
    [codigoCorretor]
  );

  const handleWhatsappNumber = (event: string) => {
    setState({
      type: StepsFormActions.setWhatsappNumber,
      payload: event
    });
  };

  const handleCompanyTitle = (event: string) => {
    setState({
      type: StepsFormActions.setCompanyTitle,
      payload: event
    });
  };

  const handleCompanySubtitle = (event: string) => {
    setState({
      type: StepsFormActions.setCompanySubtitle,
      payload: event
    });
  };

  useEffect(() => {
    handleGetWebsite();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    listAllImages().then((imagens) => {
      setCorretorImages(imagens);
    });

    getPartner();
  }, []);

  return (
    <>
      <WhiteLabelWrapper>
        <Box p="40px 56px">
          <VStack gap="30px">
            <HStack w="100%" justifyContent="space-between">
              <Box>
                <Heading>Configuração do site</Heading>
                <Text>Construa seu site aqui! Insira no menu sua Marca</Text>
              </Box>
              <WhiteLabelSteps currentStep={1} />
            </HStack>
            <Box
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
            >
              <VStack p="30px" borderBottom="1px solid #D9D9D9">
                <Box width="100%">
                  <Heading
                    fontSize="1.5rem"
                    fontStyle="normal"
                    fontWeight="700"
                    color="#001E64"
                  >
                    Estrutura de vendas
                  </Heading>
                </Box>
                <HStack
                  m="0 !important"
                  w="100%"
                  pt="30px"
                  pb="10px"
                  flexDirection="column"
                  alignItems="start !important"
                >
                  <Text>Selecione em qual EV deseja criar o seu site*</Text>
                  <Box marginInlineStart="0 !important" width="313px" pt="10px">
                    <Select
                      marginInlineStart="0 !important"
                      width="100%"
                      borderRadius="6px"
                      bg="#FFFFFF"
                      border="1px solid #001E64 !important"
                      placeholder="EV"
                      value={state.ev}
                      onChange={async (e: any) => {
                        setState({
                          type: StepsFormActions.setEv,
                          payload: Number(e.target.value)
                        });
                      }}
                      _placeholder={{
                        color: '#828282',
                        fontSize: '1rem',
                        fontWeight: '400',
                        lineHeight: '1.5rem'
                      }}
                      _hover={{}}
                      _focus={{
                        '&:focus': {
                          boxShadow: 'none !important'
                        }
                      }}
                      _active={{}}
                    >
                      {dataListPartner?.map((item, index) => {
                        return (
                          <option key={index} value={item.cod_estr_venda}>
                            {item.cod_estr_venda} - {item.nome}
                          </option>
                        );
                      })}
                    </Select>
                  </Box>
                </HStack>
              </VStack>

              {/* <VStack p="30px">
                <Box width="100%">
                  <Heading
                    fontSize="1.5rem"
                    fontStyle="normal"
                    fontWeight="700"
                    color="#001E64"
                  >
                    Qual cor você prefere para seus botões?
                  </Heading>
                </Box>
                <HStack
                  m="0 !important"
                  justifyContent="start"
                  columnGap="118px"
                  w="100%"
                  pt="30px"
                  pb="10px"
                  flexWrap="wrap"
                  flexDirection="column"
                  alignItems="start !important"
                >
                  <HStack bg="#F4F4F4" borderRadius="6px">
                    <Box
                      bg="#F4F4F4"
                      w="107px"
                      h="107px"
                      borderRadius="6px 0 0 6px"
                      padding="20px"
                      borderRight="1px solid #D2D2D2"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box
                        h="100%"
                        w="100%"
                        bg={
                          state.currentButtonsColor == null
                            ? ' #FFFFFF'
                            : state.currentButtonsColor
                        }
                        borderRadius="6px"
                      ></Box>
                    </Box>
                    <Box
                      bg="#F4F4F4"
                      h="107px"
                      borderRadius="0 6px 6px 0"
                      padding="0 40px"
                      ml="0 !important"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <ColorPalette
                        initialPickerColor={state.currentButtonsColor}
                        setCurrentColor={(e) => {
                          setState({
                            type: StepsFormActions.setCurrentButtonsColor,
                            payload: e
                          });
                        }}
                      >
                        <Button
                          bg="transparent"
                          border="1px solid #FF5000"
                          borderRadius="133.5px"
                          color="#FF5000"
                          p="0 48px"
                          h="47px"
                          _hover={{}}
                          sx={{
                            '&:focus': {
                              boxShadow: 'none !important'
                            }
                          }}
                        >
                          Adicionar uma cor
                        </Button>
                      </ColorPalette>
                    </Box>
                  </HStack>
                  <Box
                    bg="#F4F4F4"
                    h="107px"
                    borderRadius="6px"
                    padding="18.5px 23px"
                    ml="0 !important"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Button
                      bg={state.currentButtonsColor}
                      border="1px dashed #AAAAAA;"
                      borderRadius="133.5px"
                      color={
                        tinycolor(state.currentButtonsColor).getBrightness() > 127
                          ? '#5A5A5A'
                          : 'white'
                      }
                      p="0 119.8px"
                      height="61px"
                      width="408px"
                      _hover={{}}
                      sx={{
                        '&:focus': {
                          boxShadow: 'none !important'
                        }
                      }}
                      cursor="default"
                    >
                      Escolher
                    </Button>
                  </Box>
                  {criticalGecad.COR_BOTOES ? (
                    <BoxCritical
                      maxWidth={'416px'}
                      textContent={criticalGecad.COR_BOTOES}
                    />
                  ) : undefined}
                </HStack>
              </VStack>
 */}
            </Box>
            <Box
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
            >
              <VStack p="30px" borderBottom="1px solid #D9D9D9">
                <Box width="100%">
                  <Heading
                    fontSize="1.5rem"
                    fontStyle="normal"
                    fontWeight="700"
                    color="#001E64"
                  >
                    Qual cor você prefere para seu site?
                  </Heading>
                </Box>
                <HStack
                  m="0 !important"
                  w="100%"
                  pt="30px"
                  pb="10px"
                  flexDirection="column"
                  alignItems="start !important"
                >
                  <HStack bg="#F4F4F4" borderRadius="6px">
                    <Box
                      w="107px"
                      h="107px"
                      borderRadius="6px 0 0 6px"
                      padding="20px"
                      borderRight="1px solid #D2D2D2"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box
                        h="100%"
                        w="100%"
                        bg={
                          state.currentWebsiteColor == null
                            ? ' #FF5000'
                            : state.currentWebsiteColor
                        }
                        borderRadius="6px"
                      ></Box>
                    </Box>
                    <Box
                      h="107px"
                      borderRadius="0 6px 6px 0"
                      padding="0 40px"
                      ml="0 !important"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <ColorPalette
                        initialPickerColor={state.currentWebsiteColor}
                        setCurrentColor={(e) => {
                          setState({
                            type: StepsFormActions.setCurrentWebsiteColor,
                            payload: e
                          });
                        }}
                      >
                        <Button
                          bg="transparent"
                          border="1px solid #FF5000"
                          borderRadius="133.5px"
                          color="#FF5000"
                          p="0 48px"
                          h="47px"
                          _hover={{}}
                          sx={{
                            '&:focus': {
                              boxShadow: 'none !important'
                            }
                          }}
                        >
                          Adicionar uma cor
                        </Button>
                      </ColorPalette>
                    </Box>
                  </HStack>
                  {criticalGecad.COR_SITE ? (
                    <BoxCritical
                      maxWidth={'416px'}
                      textContent={criticalGecad.COR_SITE}
                    />
                  ) : undefined}
                </HStack>
              </VStack>

              {/* <VStack p="30px">
                <Box width="100%">
                  <Heading
                    fontSize="1.5rem"
                    fontStyle="normal"
                    fontWeight="700"
                    color="#001E64"
                  >
                    Qual cor você prefere para seus botões?
                  </Heading>
                </Box>
                <HStack
                  m="0 !important"
                  justifyContent="start"
                  columnGap="118px"
                  w="100%"
                  pt="30px"
                  pb="10px"
                  flexWrap="wrap"
                  flexDirection="column"
                  alignItems="start !important"
                >
                  <HStack bg="#F4F4F4" borderRadius="6px">
                    <Box
                      bg="#F4F4F4"
                      w="107px"
                      h="107px"
                      borderRadius="6px 0 0 6px"
                      padding="20px"
                      borderRight="1px solid #D2D2D2"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box
                        h="100%"
                        w="100%"
                        bg={
                          state.currentButtonsColor == null
                            ? ' #FFFFFF'
                            : state.currentButtonsColor
                        }
                        borderRadius="6px"
                      ></Box>
                    </Box>
                    <Box
                      bg="#F4F4F4"
                      h="107px"
                      borderRadius="0 6px 6px 0"
                      padding="0 40px"
                      ml="0 !important"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <ColorPalette
                        initialPickerColor={state.currentButtonsColor}
                        setCurrentColor={(e) => {
                          setState({
                            type: StepsFormActions.setCurrentButtonsColor,
                            payload: e
                          });
                        }}
                      >
                        <Button
                          bg="transparent"
                          border="1px solid #FF5000"
                          borderRadius="133.5px"
                          color="#FF5000"
                          p="0 48px"
                          h="47px"
                          _hover={{}}
                          sx={{
                            '&:focus': {
                              boxShadow: 'none !important'
                            }
                          }}
                        >
                          Adicionar uma cor
                        </Button>
                      </ColorPalette>
                    </Box>
                  </HStack>
                  <Box
                    bg="#F4F4F4"
                    h="107px"
                    borderRadius="6px"
                    padding="18.5px 23px"
                    ml="0 !important"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Button
                      bg={state.currentButtonsColor}
                      border="1px dashed #AAAAAA;"
                      borderRadius="133.5px"
                      color={
                        tinycolor(state.currentButtonsColor).getBrightness() > 127
                          ? '#5A5A5A'
                          : 'white'
                      }
                      p="0 119.8px"
                      height="61px"
                      width="408px"
                      _hover={{}}
                      sx={{
                        '&:focus': {
                          boxShadow: 'none !important'
                        }
                      }}
                      cursor="default"
                    >
                      Escolher
                    </Button>
                  </Box>
                  {criticalGecad.COR_BOTOES ? (
                    <BoxCritical
                      maxWidth={'416px'}
                      textContent={criticalGecad.COR_BOTOES}
                    />
                  ) : undefined}
                </HStack>
              </VStack>
 */}
            </Box>
            <Box
              padding="30px"
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
            >
              <VStack alignItems="start">
                <Heading
                  fontSize="1.5rem"
                  fontStyle="normal"
                  fontWeight="700"
                  color="#001E64"
                >
                  Qual o nome do seu site?
                </Heading>
                <HStack mt="30px !important" gap="40px" flexWrap="wrap">
                  <Box>
                    <Text fontSize="1rem">Digite o nome do seu site*</Text>
                    <Input
                      id={'Qual o nome do seu site?'}
                      ref={fieldsInputRefWebsiteName}
                      value={state.websiteTitle}
                      type="text"
                      border="1px solid #001E64 !important"
                      outline="none !important"
                      placeholder="Digite o nome do seu site"
                      minW="400px"
                      onChange={(event) => {
                        setState({
                          type: StepsFormActions.setWebSiteTitle,
                          payload: event.target.value
                        });
                        const websiteURL = event.target.value
                          .trim()
                          .replace(/\s/g, '')
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, '')
                          .replace(/[^A-Za-z0-9]/g, '')
                          .toLowerCase();

                        if (websiteURL.length > 0) {
                          setState({
                            type: StepsFormActions.setWebsiteAddress,
                            payload: `${websiteURL}`
                          });
                        }

                        checkNameAvailabilityNoMessage(
                          idWebsite ? idWebsite : '',
                          event.target.value
                        );
                      }}
                      onBlur={(e) =>
                        checkNameAvailability(
                          idWebsite ? idWebsite : '',
                          e.target.value
                        )
                      }
                    ></Input>
                  </Box>
                  <Box marginLeft="0 !important">
                    <Text fontSize="1rem">
                      O endereço do seu site vai ficar assim:
                    </Text>
                    <Input
                      type="text"
                      placeholder={`https://corretorexemplo.${getDominio()}`}
                      border="1px solid #001E64 !important"
                      outline="none !important"
                      minW="400px"
                      disabled
                      opacity="1 !important"
                      value={
                        state.websiteAddress
                          ? `https://${state.websiteAddress}.${getDominio()}`
                          : ''
                      }
                    ></Input>
                  </Box>
                </HStack>
                {criticalGecad.NOME_SITE ? (
                  <BoxCritical
                    maxWidth={'416px'}
                    textContent={criticalGecad.NOME_SITE}
                  />
                ) : undefined}
              </VStack>
            </Box>
            <Box
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
              padding="30px 0px"
            >
              <Box padding="0px 30px">
                <Heading
                  fontSize="1.5rem"
                  fontStyle="normal"
                  fontWeight="700"
                  color="#001E64"
                >
                  Cabeçalho
                </Heading>
                <Text
                  marginTop="20px"
                  fontSize="1.25rem"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="2rem"
                  color="#323232"
                >
                  Agora vamos adicionar seu logotipo*
                </Text>
                <Box
                  marginTop="10px"
                  width="100%"
                  fontWeight="400"
                  fontSize="1rem"
                  lineHeight="1.5rem"
                  color="#323232"
                  display="inline-block"
                >
                  <Text display="inline-block">
                    Sua imagem deve conter&nbsp;
                  </Text>
                  <Text display="inline-block" fontWeight="700">
                    150px de largura por 40px de altura.
                  </Text>
                  <Box as="br" />
                  <Text display="inline-block">Formato suportado&nbsp;</Text>
                  <Text display="inline-block" fontWeight="700">
                    JPEG ou PNG.
                  </Text>
                </Box>
                <VStack
                  marginTop="20px"
                  width="100%"
                  borderRadius="15px"
                  background="#F4F4F4"
                  padding="30px"
                >
                  <HStack width="100%" marginBottom="0px !important">
                    <Stack>
                      <Box
                        bg={
                          previewImage.includes('undefined')
                            ? '#FFFFFF'
                            : previewImage
                        }
                        position="relative"
                        backgroundPosition="center"
                        backgroundRepeat="no-repeat"
                        backgroundSize="contain"
                        width="204px"
                        height="100px"
                        borderRadius="14px"
                        border={'1px dashed #AAAAAA'}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Text
                          fontSize="1rem"
                          fontWeight="400"
                          lineHeight="1.5rem"
                          color="#5A5A5A"
                          textAlign="center"
                        >
                          {previewImage.includes('undefined')
                            ? 'Sua imagem aparecerá aqui'
                            : undefined}
                        </Text>

                        <Button
                          w="9px"
                          position="absolute"
                          bottom="0"
                          right="0"
                          bg="transparent"
                          borderRadius="50%"
                          visibility={
                            previewImage.includes('undefined')
                              ? 'hidden'
                              : 'visible'
                          }
                          onClick={async () => {
                            setPreviewImage('url(undefined)');
                            await setState({
                              type: StepsFormActions.setSelectedFileLogo,
                              payload: ''
                            });
                            await setState({
                              type: StepsFormActions.setSelectedFileLogoName,
                              payload: ''
                            });
                          }}
                          _hover={{}}
                          _active={{}}
                          _focus={{
                            '&:focus': {
                              boxShadow: 'none !important'
                            }
                          }}
                        >
                          <TrashIcon w="40px" h="30px" />
                        </Button>
                      </Box>
                      <Text
                        marginTop="10px"
                        marginBottom="30px"
                        fontSize="0.875rem"
                        lineHeight="1.5rem"
                        fontWeight="400"
                        color="#000000"
                      >
                        Tamanho maximo permitido: 1mb
                      </Text>
                    </Stack>

                    <Box>
                      <Button
                        id="openUploadLogo"
                        onClick={handleUploadLogo}
                        marginLeft="30px !important"
                        marginRight="21px !important"
                        background="transparent"
                        width="282px"
                        height="48px"
                        padding="13px 48px"
                        border="1px solid #FF5000"
                        borderRadius="133.5px"
                        color="#FF5000"
                        fontWeight="700"
                        fontSize="1rem"
                        lineHeight="22px"
                        gap="15px"
                        _hover={{ background: '#ffff' }}
                        _focus={{
                          '&:focus': {
                            boxShadow: 'none !important'
                          }
                        }}
                        _active={{}}
                      >
                        <UploadIcon width="1rem" height="1rem" />
                        Escolher sua imagem
                      </Button>
                      <Input
                        id="imgUploadLogo"
                        type="file"
                        display="none"
                        onClick={(e) => {
                          e.currentTarget.value = '';
                        }}
                        onChange={(e) => {
                          handleChangeLogo(e);
                        }}
                      />
                    </Box>
                    {/* <Text
                      margin="0 !important"
                      fontSize="0.875rem"
                      fontWeight="400"
                      lineHeight="1.5rem"
                      color="#000000"
                    >
                      {state.selectedFileLogo === null
                        ? 'Nenhum item selecionado'
                        : state.selectedFileLogo === ''
                        ? 'Nenhum item selecionado'
                        : nameImgLogo}
                    </Text> */}
                  </HStack>
                </VStack>
                {criticalGecad.LOGO ? (
                  <BoxCritical
                    maxWidth={'416px'}
                    textContent={criticalGecad.LOGO}
                  />
                ) : undefined}
                <Text
                  marginTop="30px"
                  fontSize="1.25rem"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="2rem"
                  color="#323232"
                >
                  Caso não tenha um logotipo você pode adicionar
                  <Box as="br" />
                  um nome para sua pagina no lugar do logotipo.
                </Text>
                <VStack
                  marginTop="20px"
                  width="100%"
                  borderRadius="15px"
                  background="#F4F4F4"
                  padding="30px"
                >
                  <HStack width="100%" margin="0px !important">
                    <Stack>
                      <Text
                        fontSize="0.875rem"
                        fontWeight="400"
                        color="#000000"
                      >
                        Digite o nome da sua página
                      </Text>
                      <Box width="400px">
                        <Input
                          id={'Digite o nome da sua página'}
                          ref={fieldsInputRefLogoName}
                          disabled={!!hasLogo}
                          value={state.selectedNameLogo}
                          onChange={(event) => {
                            setState({
                              type: StepsFormActions.setSelectedNameLogo,
                              payload: event.target.value
                            });

                            setSelectedNameLogoLength(
                              event.target.value.length
                            );
                          }}
                          type="text"
                          bg="white"
                          placeholder="Digite o nome da sua página"
                          width="100%"
                          height="50px"
                          fontSize="16px"
                          maxLength={12}
                          sx={{
                            '&:focus': {
                              boxShadow: 'none !important'
                            }
                          }}
                          border="1px solid #001E64 !important"
                        ></Input>
                        <Text
                          textAlign="right"
                          fontSize="0.875rem"
                          lineHeight="24px"
                          mt="5px"
                        >
                          {selectedNameLogoLength}/12 caracteres
                        </Text>
                      </Box>
                    </Stack>
                  </HStack>
                </VStack>
                {criticalGecad.LOGO_PALAVRA ? (
                  <BoxCritical
                    maxWidth={'416px'}
                    textContent={criticalGecad.LOGO_PALAVRA}
                  />
                ) : undefined}
                <Text
                  marginTop="46px"
                  fontSize="1.25rem"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="2rem"
                  color="#323232"
                >
                  Deseja incluir o logotipo da SulAmérica?
                </Text>
                <RadioGroup
                  value={state.logoSulamerica ? 'sim' : 'nao'}
                  onChange={(e) => {
                    const res = e == 'sim' ? true : false;
                    setState({
                      type: StepsFormActions.setLogoSulamerica,
                      payload: res
                    });
                  }}
                >
                  <HStack gap="40px">
                    <Radio value="sim" colorScheme="custom">
                      Sim
                    </Radio>
                    <Radio value="nao" colorScheme="custom">
                      Não
                    </Radio>
                  </HStack>
                </RadioGroup>
                <VStack
                  marginTop="20px"
                  width="100%"
                  borderRadius="15px"
                  background="#F4F4F4"
                  padding="30px"
                >
                  <HStack width="100%" margin="0px !important" gap="20px">
                    <Box
                      bg={
                        previewImage.includes('undefined')
                          ? '#FFFFFF'
                          : previewImage
                      }
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="contain"
                      width="204px"
                      height="100px"
                      borderRadius="14px"
                      border="1px dashed #AAAAAA"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Text
                        fontSize={state.selectedNameLogo ? '2rem' : '1rem'}
                        fontWeight={state.selectedNameLogo ? '700' : '400'}
                        lineHeight={state.selectedNameLogo ? '3rem' : '1.5rem'}
                        color={state.selectedNameLogo ? '#000000' : ' #5A5A5A'}
                        textAlign="center"
                        visibility={
                          previewImage.includes('undefined')
                            ? 'visible'
                            : 'hidden'
                        }
                      >
                        {state.selectedNameLogo
                          ? state.selectedNameLogo
                          : 'seu logotipo/nome da página'}
                      </Text>
                    </Box>
                    <Box margin="0 !important">
                      <PlusIcon />
                    </Box>
                    <Box margin="0 !important" maxW="152px">
                      <Image w="100%" src="/images/logo-sulAmerica.png" />
                    </Box>
                  </HStack>
                </VStack>
              </Box>
              <Box p="0 6px" mt="29px">
                <Divider orientation="horizontal" />
              </Box>
              <Box p="34px 30px 0 30px">
                <Text
                  fontSize="1.25rem"
                  fontStyle="normal"
                  fontWeight="700"
                  lineHeight="2rem"
                  color="#323232"
                >
                  Vamos adicionar o WhatsApp em seu site
                </Text>
                <Text fontSize="1rem" mt="10px" color="black">
                  Adicione um numero de telefone do seu whatsapp*
                </Text>
                <Text fontSize="1rem" mt="20px" color="black">
                  Número
                </Text>
                <Box w="400px">
                  <Input
                    id="Adicione o número de telefone do seu whatsapp"
                    ref={fieldsInputRefWhatsappNumber}
                    value={state.whatsappNumber}
                    type="text"
                    bg="white"
                    placeholder="(00)00000-0000"
                    width="100%"
                    height="50px"
                    fontSize="16px"
                    onChange={(e) => {
                      const withoutNumber = e.target.value.replace(
                        /[^0-9]/g,
                        ''
                      );
                      handleWhatsappNumber(withoutNumber);
                    }}
                    sx={{
                      '&:focus': {
                        boxShadow: 'none !important'
                      }
                    }}
                    border="1px solid #001E64 !important"
                  />
                </Box>
                {criticalGecad.NUMERO_WHATSAPP ? (
                  <BoxCritical
                    maxWidth={'416px'}
                    textContent={criticalGecad.NUMERO_WHATSAPP}
                  />
                ) : undefined}
              </Box>
            </Box>
            <Box
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
              padding="30px"
            >
              <Heading
                fontSize="1.5rem"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="2rem"
                color="#001E64"
              >
                Seção 1
              </Heading>
              <Text
                id="bannerStepOne"
                marginTop="20px"
                fontSize="1.25rem"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="2rem"
                color="#323232"
              >
                Agora vamos adicionar seu banner
              </Text>
              <Box
                marginTop="10px"
                width="100%"
                fontWeight="400"
                fontSize="1rem"
                lineHeight="1.5rem"
                color="#323232"
                display="inline-block"
              >
                <Box>
                  <Text display="inline-block">
                    Sua imagem deve conter&nbsp;
                  </Text>
                  <Text display="inline-block" fontWeight="700">
                    800px de largura por 360px de altura.
                  </Text>
                </Box>
                <Box>
                  <Text display="inline-block">formato suportado&nbsp;</Text>
                  <Text display="inline-block" fontWeight="700">
                    JPEG ou PNG.
                  </Text>
                </Box>
              </Box>
              <VStack
                marginTop="20px"
                width="100%"
                borderRadius="15px"
                background="#F4F4F4"
                padding="30px"
                divider={
                  <StackDivider
                    border="1px solid #D2D2D2"
                    margin="0px !important"
                  />
                }
              >
                <HStack width="100%" marginBottom="30px !important">
                  <Stack>
                    <Box
                      id="Agora vamos adicionar seu banner"
                      ref={fieldsInputRefBanner}
                      bg={
                        state.selectedFileBanner
                          ? `url(${state.selectedFileBanner})`
                          : state.selectedFileBannerName
                          ? `url(${state.selectedFileBannerName})`
                          : '#FFFFFF'
                      }
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      width="204px"
                      height="210px"
                      borderRadius="14px"
                      border={
                        // isDragBanner
                        //   ? '1px dashed #FF5000'
                        //   :
                        '1px dashed #AAAAAA'
                      }
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      // onDragLeave={(e) => {
                      //   e.preventDefault(), e.stopPropagation();
                      //   setIsDragBanner(false);
                      // }}
                      // onDragOver={(e) => {
                      //   e.preventDefault(), e.stopPropagation();
                      //   setIsDragBanner(true);
                      // }}
                      // onDrop={(e) => {
                      //   e.preventDefault(), e.stopPropagation();
                      //   setIsDragBanner(false);
                      //   handleURLImageBanner(e);
                      // }}
                    >
                      <Text
                        fontSize="1rem"
                        fontWeight="400"
                        lineHeight="1.5rem"
                        color="#5A5A5A"
                        textAlign="center"
                      >
                        {!hasBanner ? 'Sua imagem aparecerá aqui' : undefined}
                      </Text>
                    </Box>
                    <Text
                      marginTop="10px"
                      marginBottom="30px"
                      fontSize="0.875rem"
                      lineHeight="1.5rem"
                      fontWeight="400"
                      color="#000000"
                    >
                      Tamanho máximo permitido: 5MB
                    </Text>
                  </Stack>
                  <Box>
                    <Button
                      id="openUploadBanner"
                      onClick={() => {
                        setIsOpenModal(true);
                        // setState({
                        //   type: StepsFormActions.setSelectedNameLogo,
                        //   payload: ''
                        // });
                      }}
                      marginLeft="30px !important"
                      marginRight="21px !important"
                      background="transparent"
                      width="282px"
                      height="48px"
                      padding="13px 48px"
                      border="1px solid #FF5000"
                      borderRadius="133.5px"
                      color="#FF5000"
                      fontWeight="700"
                      fontSize="1rem"
                      lineHeight="22px"
                      gap="15px"
                      _hover={{ background: '#ffff' }}
                      _focus={{
                        '&:focus': {
                          boxShadow: 'none !important'
                        }
                      }}
                      _active={{}}
                    >
                      <UploadIcon width="1rem" height="1rem" />
                      Escolher sua imagem
                    </Button>
                  </Box>
                  {/* <Text
                    margin="0 !important"
                    fontSize="0.875rem"
                    fontWeight="400"
                    lineHeight="1.5rem"
                    color="#000000"
                  >
                    {state.selectedFileBanner === null
                      ? 'Nenhum item selecionado'
                      : state.selectedFileBanner === ''
                      ? 'Nenhum item selecionado'
                      : nameImgBanner}
                  </Text> */}
                </HStack>
              </VStack>
              {criticalGecad.IMAGEM_SECAO_1 ? (
                <BoxCritical
                  maxWidth={'416px'}
                  textContent={criticalGecad.IMAGEM_SECAO_1}
                />
              ) : undefined}
              <Text
                id="companyTitleStepOne"
                margin="40px 0 20px 0 !important"
                fontSize="1.25rem"
                fontWeight="700"
                lineHeight="2rem"
                display="flex"
                alignItems="center"
                gridGap="10px"
                color="#323232"
              >
                Escreva um TÍTULO para complementar o seu PRIMEIRO Banner*
                <Tooltip
                  hasArrow
                  m="0 0 5px 0!important"
                  label="Este texto acompanhará o seu primeiro Banner como mensagem principal do site"
                  bg="gray.200"
                  placement="top-start"
                  color="#323232"
                >
                  <QuestionOutlineIcon />
                </Tooltip>
              </Text>
              <VStack
                width="100%"
                borderRadius="15px"
                background="#F4F4F4"
                padding="30px 30px 59px 30px"
              >
                <Stack textAlign="end" width="100%">
                  <Textarea
                    id="Escreva um TÍTULO para complementar o seu PRIMEIRO Banner"
                    ref={fieldsInputRefTitle}
                    value={state.companyTitle}
                    resize="none"
                    placeholder="Incluir texto"
                    height="172px"
                    borderRadius="6px"
                    background="#FFFFFF"
                    border="1px solid #001E64 !important"
                    padding="20px"
                    _hover={{}}
                    _focus={{
                      '&:focus': {
                        boxShadow: 'none !important'
                      }
                    }}
                    _active={{}}
                    _placeholder={{
                      fontSize: '1rem',
                      color: '#828282',
                      fontWeight: '400',
                      lineHeight: '1.5rem'
                    }}
                    onChange={(event) => {
                      handleCompanyTitle(event.target.value);
                      setDescriptionCompanyTitleLength(
                        event.target.value.length
                      );
                    }}
                    maxLength={100}
                  />
                  <Text
                    margin="5px 0 0 0 !important"
                    fontSize="0.875rem"
                    fontWeight="400"
                    lineHeight="1.5rem"
                    color="#000000"
                  >
                    {descriptionCompanyTitleLength}/100 caracteres
                  </Text>
                </Stack>
              </VStack>
              {criticalGecad.TITULO_SECAO_1 ? (
                <BoxCritical
                  maxWidth={'416px'}
                  textContent={criticalGecad.TITULO_SECAO_1}
                />
              ) : undefined}
              <Text
                margin="30px 0 20px 0 !important"
                fontSize="1.25rem"
                fontWeight="700"
                lineHeight="2rem"
                color="#323232"
                display="flex"
                alignItems="center"
                gridGap="10px"
              >
                Escreva um SUBTÍTULO para complementar o seu PRIMEIRO Banner*
                <Tooltip
                  hasArrow
                  m="0 0 5px 0!important"
                  label="Este texto acompanhará o seu primeiro Banner como mensagem secundária do site"
                  bg="gray.200"
                  placement="top-start"
                  color="#323232"
                >
                  <QuestionOutlineIcon />
                </Tooltip>
              </Text>
              <VStack
                width="100%"
                borderRadius="15px"
                background="#F4F4F4"
                padding="30px 30px 59px 30px"
              >
                <Stack textAlign="end" width="100%">
                  <Textarea
                    id="Escreva um SUBTÍTULO para complementar o seu PRIMEIRO Banner"
                    ref={fieldsInputRefSubtitle}
                    value={state.companySubtitle}
                    resize="none"
                    placeholder="Incluir texto"
                    height="172px"
                    borderRadius="6px"
                    background="#FFFFFF"
                    border="1px solid #001E64 !important"
                    padding="20px"
                    _hover={{}}
                    _focus={{
                      '&:focus': {
                        boxShadow: 'none !important'
                      }
                    }}
                    _active={{}}
                    _placeholder={{
                      fontSize: '1rem',
                      color: '#828282',
                      fontWeight: '400',
                      lineHeight: '1.5rem'
                    }}
                    onChange={(event) => {
                      handleCompanySubtitle(event.target.value);
                      setDescriptionCompanySubtitleLength(
                        event.target.value.length
                      );
                    }}
                    maxLength={200}
                  />
                  <Text
                    margin="5px 0 0 0 !important"
                    fontSize="0.875rem"
                    fontWeight="400"
                    lineHeight="1.5rem"
                    color="#000000"
                  >
                    {descriptionCompanySubtitleLength}/200 caracteres
                  </Text>
                </Stack>
              </VStack>
              {criticalGecad.SUBTITULO_SECAO_1 ? (
                <BoxCritical
                  maxWidth={'416px'}
                  textContent={criticalGecad.SUBTITULO_SECAO_1}
                />
              ) : undefined}
            </Box>
            <WhiteLabelNavigator
              nextAction={(e: any) => {
                handleSubmit(e);
              }}
              hrefPrev="/corretor/white-label/painel"
              btnNextText={'Salvar e Continuar'}
            />
          </VStack>
        </Box>
      </WhiteLabelWrapper>
      <ModalCropImageLogo
        image={state.selectedFileLogo}
        onImageCropped={handleLogoImageAfterCropped}
        isOpen={isOpenModalCropLogo}
        onClose={onCloseModalCropLogo}
        // aspect={150 / 50}
      />

      <ModalSelectBannerImage
        images={corretorImages}
        codigoCorretor={codigoCorretor}
        isOpenModal={isOpenModal}
        handleModalSelectImage={handleModalSelectImage}
        handleImageSelectedGalleryBanner={handleImageSelectedGalleryBanner}
      />
    </>
  );
};
